/* LEDPLANET - Toolmail + Delen, koppelingen (17-10-2026). Geeft bestaande pagina's het blok uit assets/lp-toolmail.js
   zonder dat hun eigen code verandert: productpagina's en kennisbank-artikelen (alleen delen), /pages/besparingscalculator,
   /pages/railsysteem-samenstellen, /pages/lichtplan en /pages/lichtberekenaar. Geladen via snippets/ledplanet-toolmail. */
(function () {
  'use strict';
  var EUR = new RegExp(String.fromCharCode(8364), 'g');
  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('lp-tm-cfg').textContent); } catch (e) {}
  var TAAL = CFG.taal || 'nl';
  if (!window.LPToolmail || !window.LPToolmail.echt) return;
  function schoon(s) { return String(s == null ? '' : s).replace(EUR, '').replace(/[<>]/g, '').replace(/\s+/g, ' ').trim(); }
  function mount(el, o) { return window.LPToolmail.mount(el, o); }
  function delenMount(el, o) { return window.LPDelen.mount(el, o); }

  /* =====================================================================
     Koppelingen: bestaande pagina's krijgen het blok zonder dat hun eigen code verandert.
     ===================================================================== */
  var NF = new Intl.NumberFormat(TAAL === 'en' ? 'en-GB' : TAAL === 'nl' ? 'nl-NL' : TAAL, { maximumFractionDigits: 2 });
  var NF2 = new Intl.NumberFormat(TAAL === 'en' ? 'en-GB' : TAAL === 'nl' ? 'nl-NL' : TAAL, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function fmt(s, o) { return String(s).replace(/\{(\w+)\}/g, function (m, k) { return o[k] == null ? '' : o[k]; }); }
  var A = {
    nl: { rs: 'Mijn railsysteem-ontwerp', lp: 'Mijn lichtplan', lb: 'Mijn lichtadvies', tot: 'Totaal incl. btw', bs: 'Mijn LED-besparing', pj: 'per jaar',
      ba: '{n} lamp(en): {wo} W oud naar {wl} W LED, {u} branduren per jaar, {k} euro per kWh', bb: 'Besparing per jaar: {kwh} kWh en {eur} euro', bc: 'Minder CO2: {co2} kg per jaar' },
    de: { rs: 'Mein Schienensystem-Entwurf', lp: 'Mein Lichtplan', lb: 'Meine Lichtempfehlung', tot: 'Gesamt inkl. MwSt.', bs: 'Meine LED-Ersparnis', pj: 'pro Jahr',
      ba: '{n} Lampe(n): {wo} W alt zu {wl} W LED, {u} Brennstunden pro Jahr, {k} Euro pro kWh', bb: 'Ersparnis pro Jahr: {kwh} kWh und {eur} Euro', bc: 'Weniger CO2: {co2} kg pro Jahr' },
    en: { rs: 'My track lighting design', lp: 'My lighting plan', lb: 'My lighting advice', tot: 'Total incl. VAT', bs: 'My LED savings', pj: 'per year',
      ba: '{n} lamp(s): {wo} W old to {wl} W LED, {u} burning hours per year, {k} euro per kWh', bb: 'Savings per year: {kwh} kWh and {eur} euro', bc: 'Less CO2: {co2} kg per year' },
    fr: { rs: 'Mon projet de rail', lp: 'Mon plan d’éclairage', lb: 'Mon conseil d’éclairage', tot: 'Total TTC', bs: 'Mes économies avec la LED', pj: 'par an',
      ba: '{n} lampe(s) : {wo} W ancienne vers {wl} W LED, {u} heures par an, {k} euro par kWh', bb: 'Économie par an : {kwh} kWh et {eur} euros', bc: 'Moins de CO2 : {co2} kg par an' },
    es: { rs: 'Mi diseño de carril', lp: 'Mi plan de iluminación', lb: 'Mi consejo de iluminación', tot: 'Total IVA incl.', bs: 'Mi ahorro con LED', pj: 'al año',
      ba: '{n} lámpara(s): {wo} W antigua a {wl} W LED, {u} horas al año, {k} euros por kWh', bb: 'Ahorro al año: {kwh} kWh y {eur} euros', bc: 'Menos CO2: {co2} kg al año' },
    it: { rs: 'Il mio progetto a binario', lp: 'Il mio progetto luci', lb: 'Il mio consiglio luci', tot: 'Totale IVA incl.', bs: 'Il mio risparmio LED', pj: 'all’anno',
      ba: '{n} lampada/e: {wo} W vecchia a {wl} W LED, {u} ore all’anno, {k} euro per kWh', bb: 'Risparmio annuo: {kwh} kWh e {eur} euro', bc: 'Meno CO2: {co2} kg all’anno' },
    pl: { rs: 'Mój projekt szynoprzewodu', lp: 'Mój plan oświetlenia', lb: 'Moja porada oświetleniowa', tot: 'Razem z VAT', bs: 'Moja oszczędność z LED', pj: 'rocznie',
      ba: '{n} lamp(y): {wo} W stara na {wl} W LED, {u} godzin rocznie, {k} euro za kWh', bb: 'Oszczędność rocznie: {kwh} kWh i {eur} euro', bc: 'Mniej CO2: {co2} kg rocznie' }
  }[TAAL] || null;
  if (!A) A = { rs: 'My track lighting design', lp: 'My lighting plan', lb: 'My lighting advice', tot: 'Total incl. VAT', bs: 'My LED savings', pj: 'per year',
    ba: '{n} lamp(s): {wo} W old to {wl} W LED, {u} burning hours per year, {k} euro per kWh', bb: 'Savings per year: {kwh} kWh and {eur} euro', bc: 'Less CO2: {co2} kg per year' };

  function probeer(fn, keer, wacht) { var n = 0; (function p() { if (!fn() && ++n < keer) setTimeout(p, wacht); })(); }
  function tekstVan(sel) { var e = typeof sel === 'string' ? document.querySelector(sel) : sel; return e ? schoon(e.textContent) : ''; }
  function verberg(sel) { var e = document.querySelector(sel); if (e) e.style.display = 'none'; return e; }
  // onderdelenlijst (railsysteem / lichtplan): {out: [{n, p: {t, u, img, pr (centen)}, lab}]}
  function onderdelen(res) {
    var out = (res && res.out) || [];
    return {
      regels: out.map(function (x) { return x.n + 'x ' + (x.p ? x.p.t : (x.lab || '')); }),
      producten: out.filter(function (x) { return x.p && x.p.u; }).map(function (x) {
        return { url: x.p.u, titel: x.p.t, img: x.p.img, prijs: typeof x.p.pr === 'number' ? (x.p.pr / 100).toFixed(2).replace('.', ',') : x.p.pr };
      })
    };
  }

  // productpagina: rustige deelrij onder de offerte-regel
  function koppelProduct() {
    var anker = document.getElementById('lp-offerte') || document.querySelector('.product-info__sticky .lp-pp-specs') || document.querySelector('.product-info__sticky .product-price');
    if (!anker) return false;
    var titel = tekstVan('.product-info__title h1') || tekstVan('.product-info__title') || schoon(document.title);
    delenMount(anker, { plaats: 'na', klein: true, titel: titel, deelTekst: titel, link: function () {
      var v = new URLSearchParams(location.search).get('variant');
      return location.origin + location.pathname + (v ? '?variant=' + encodeURIComponent(v) : '');
    } });
    return true;
  }
  // kennisbank-artikel: de deelknoppen van het thema vervangen door dezelfde rustige rij
  function koppelArtikel() {
    var oud = document.querySelector('.social-share');
    var anker = oud || document.querySelector('.article-template__content, .article__content, article .rte');
    if (!anker) return false;
    var titel = tekstVan('h1') || schoon(document.title);
    var blok = delenMount(anker, { plaats: 'na', titel: titel, deelTekst: titel, link: function () { return location.origin + location.pathname; } });
    if (oud && blok) { oud.style.display = 'none'; blok.classList.add('reading-width', 'article-width', 'mx-auto'); blok.style.marginTop = '32px'; }
    return true;
  }
  // /pages/besparingscalculator: uitkomst in de link (?n=&wo=&wl=&ud=&uj=&k=) + mailblok onder de tabel
  function koppelBesparing() {
    var f = document.getElementById('besparingscalculatorForm');
    if (!f) return false;
    var V = { n: 'aantal_lampen', wo: 'wattage_lamp', wl: 'wattage_led_lamp', ud: 'branduren_per_dag', uj: 'branduren_per_jaar', k: 'prijs_per_kwh' };
    var p = new URLSearchParams(location.search), gezet = false;
    Object.keys(V).forEach(function (k) { var e = document.getElementById(V[k]); if (e && p.has(k) && /^[0-9.,]{1,10}$/.test(p.get(k))) { e.value = p.get(k); gezet = true; } });
    if (gezet) { var e0 = document.getElementById('aantal_lampen'); if (e0) e0.dispatchEvent(new Event('input', { bubbles: true })); }
    function w(id) { var e = document.getElementById(id); return e ? String(e.value || '').trim() : ''; }
    function g(id) { return parseFloat(String(tekstVan('#' + id)).replace(',', '.')) || 0; }
    function link() {
      var q = new URLSearchParams();
      Object.keys(V).forEach(function (k) { var v = w(V[k]); if (v) q.set(k, v); });
      return location.origin + location.pathname + '?' + q.toString();
    }
    mount(f, { plaats: 'na', tool: 'besparingscalculator', soort: 'berekening', link: link,
      titel: function () { return A.bs + ': ' + NF.format(Math.round(g('bespaar_euro_totaal'))) + ' euro ' + A.pj; },
      samenvatting: function () {
        return [fmt(A.ba, { n: w('aantal_lampen'), wo: w('wattage_lamp'), wl: w('wattage_led_lamp'), u: w('branduren_per_jaar'), k: w('prijs_per_kwh') }),
          fmt(A.bb, { kwh: NF.format(g('bespaar_kwh_totaal')), eur: NF2.format(g('bespaar_euro_totaal')) }),
          fmt(A.bc, { co2: NF.format(g('bespaar_co2_totaal')) })];
      },
      deelTekst: function () { return A.bs + ': ' + fmt(A.bb, { kwh: NF.format(g('bespaar_kwh_totaal')), eur: NF2.format(g('bespaar_euro_totaal')) }); }
    });
    return true;
  }
  // /pages/railsysteem-samenstellen: ontwerp mailen + delen (vervangt de knoppen 'Link kopiëren' en 'Ontwerp mailen')
  function koppelRail() {
    var RS = window.RS2, sh = document.querySelector('#rs2 .share');
    if (!RS || !RS.encode || !RS.parts || !sh) return false;
    verberg('#rs2link'); verberg('#rs2mail'); sh.style.display = 'none';
    var o = { plaats: 'na', tool: 'railsysteem', soort: 'ontwerp', titel: A.rs,
      link: function () { return location.origin + location.pathname + '#rs2=' + RS.encode(); },
      samenvatting: function () { var r = onderdelen(RS.parts()); return [A.tot + ': ' + tekstVan('#rs2tot')].concat(r.regels.slice(0, 7)); },
      producten: function () { return onderdelen(RS.parts()).producten; },
      deelTekst: function () { var r = onderdelen(RS.parts()); return A.rs + ' (' + A.tot + ': ' + tekstVan('#rs2tot') + ')\n' + r.regels.join('\n'); }
    };
    mount(sh, o);
    return true;
  }
  // /pages/lichtplan: plan mailen + delen (vervangt 'Link kopiëren' en 'Lichtplan mailen'; printen blijft)
  function koppelLichtplan() {
    var LP = window.LP, sh = document.querySelector('#lp .share');
    if (!LP || !LP.encode || !sh || !LP.loaded && !document.getElementById('lpparts')) return false;
    verberg('#lplink'); verberg('#lpmail');
    function naam() { return LP.P && LP.P.name ? A.lp + ': ' + LP.P.name : A.lp; }
    function ruimtes() {
      return [].slice.call(document.querySelectorAll('#lprooms tr')).filter(function (tr) { return tr.querySelector('td'); }).map(function (tr) {
        return [].slice.call(tr.children).map(function (c) { return schoon(String(c.innerText || c.textContent || '').trim().split('\n')[0]); }).filter(Boolean).join(' · ');
      });
    }
    var o = { plaats: 'na', tool: 'lichtplan', soort: 'ontwerp', titel: naam,
      link: function () { return LP.encode().then(function (e) { return location.origin + location.pathname + location.search + '#lp=' + e; }); },
      samenvatting: function () { var r = onderdelen(LP.parts ? LP.parts() : null); return [A.tot + ': ' + tekstVan('#lptot')].concat(ruimtes().slice(0, 3), r.regels.slice(0, 4)); },
      producten: function () { return onderdelen(LP.parts ? LP.parts() : null).producten; },
      deelTekst: function () { return naam() + ' (' + A.tot + ': ' + tekstVan('#lptot') + ')'; }
    };
    mount(sh, o);
    return true;
  }
  // /pages/lichtberekenaar (in een shadow root, met eigen delen): mailblok onder de berekenaar.
  // Link en tekst komen uit de eigen WhatsApp-knop van de berekenaar (zonder dat er iets opent).
  function koppelLichtberekenaar() {
    var host = document.getElementById('lp-host');
    if (!host) return false;
    function vang() {
      var r = host.shadowRoot || host, b = r.querySelector('[data-share="shR"] [data-act="wa"]');
      if (!b) return null;
      var url = null, oud = window.open, kaart = b.closest('[data-share]'), msg = kaart && kaart.querySelector('[data-msg]'), mt = msg ? msg.textContent : '';
      window.open = function (u) { url = u; return null; };
      try { b.click(); } catch (e) {} finally { window.open = oud; }
      if (msg) msg.textContent = mt;
      if (!url) return null;
      var t = ''; try { t = decodeURIComponent(String(url).split('text=')[1] || ''); } catch (e) {}
      var r2 = t.split('\n').map(function (s) { return s.trim(); }).filter(Boolean);
      var link = null; r2.forEach(function (s) { var m = s.match(/https?:\/\/\S+#\S+/); if (m) link = m[0]; });
      return { link: link, regels: r2.slice(1).filter(function (s) { return !/https?:\/\//.test(s); }) };
    }
    mount(host, { plaats: 'na', tool: 'lichtberekenaar', soort: 'advies', delen: false,
      link: function () { var v = vang(); return v && v.link ? v.link : location.origin + location.pathname; },
      titel: function () { var v = vang(); return v && v.regels[0] ? A.lb + ': ' + v.regels[0] : A.lb; },
      samenvatting: function () { var v = vang(); return v ? v.regels.slice(1, 7) : []; }
    });
    return true;
  }

  var P = CFG.pagina;
  if (CFG.type === 'product') probeer(koppelProduct, 12, 500);
  else if (CFG.type === 'article') probeer(koppelArtikel, 6, 500);
  else if (P === 'besparingscalculator') probeer(koppelBesparing, 10, 400);
  else if (P === 'railsysteem-samenstellen') probeer(koppelRail, 30, 500);
  else if (P === 'lichtplan') probeer(koppelLichtplan, 40, 500);
  else if (P === 'lichtberekenaar') probeer(koppelLichtberekenaar, 10, 500);
})();